import React from "react";

export default function ({
  title,
  classes = "",
  action = () => { }
}) {
  return <button type="button"
  className={`btn btn-lg${classes ? " " + classes : ''}`}
  onClick={action}>
    <span className="indicator-label">{title}</span>
  </button>
}